<section
  id="product-category-card-55555"
  class="style-product-category-card-55555"
  (mouseenter)="showImages = true"
  (mouseleave)="showImages = false"
>
  <div
    [class.height-custom]="!isPreviewDetailsVisible && !isAddToCartVisible"
    (click)="openProductPage(productVariant.url_path)"
    class="product-card product-card-background product-card-border product-card-border-top-left-radius product-card-border-top-right-radius product-card-border-bottom-right-radius product-card-border-bottom-left-radius editable animated fadeIn"
  >
    <div>
      <div class="timer-vairants-wrapper">
        <!-- Enhanced deal countdown with better time formatting -->
        @if (remainingTime(); as remainingTime) {
          @if (isMobile()) {
            @if (categoryLayoutData().productCardData.advanceConfiguration.mobile.isDealCountdownVisible) {
              @if (remainingTime.remainingTime > 1000) {
                <div
                  class="timer-badge timer-badge-text-size timer-badge-text-color timer-badge-font-weight timer-badge-background timer-badge-margin-alignment"
                >
                  @if (
                    productDealCountDown.description && selectedMobileGridLayout() !== MOBILE_GRID_LAYOUT.GRID_LAYOUT2
                  ) {
                    {{ productDealCountDown.badge_message + ' ' }}
                  }
                  @if (remainingTime.daysToToday) {
                    {{ remainingTime.daysToToday }}{{ remainingTime.daysToToday > 0 ? 'd : ' : '' }}
                  }
                  @if (remainingTime.hoursToToday) {
                    {{ remainingTime.hoursToToday }}{{ remainingTime.hoursToToday > 0 ? 'h : ' : '' }}
                  }
                  {{ remainingTime.minutesToToday }}m : {{ remainingTime.secondsToToday }}s
                </div>
              }
            }
          } @else {
            @if (categoryLayoutData().productCardData.advanceConfiguration.desktop.isDealCountdownVisible) {
              <!-- Enhanced desktop countdown with better formatting -->
              @if (remainingTime.daysToToday > 0) {
                <div
                  class="timer-badge timer-badge-text-size timer-badge-text-color timer-badge-font-weight timer-badge-background timer-badge-margin-alignment"
                >
                  {{
                    productDealCountDown.badge_message +
                      ' ' +
                      remainingTime.daysToToday +
                      (remainingTime.daysToToday > 1 ? ' Days' : ' Day')
                  }}
                </div>
              } @else if (remainingTime.daysToToday < 1 && remainingTime.hoursToToday >= 1) {
                <div
                  class="timer-badge timer-badge-text-size timer-badge-text-color timer-badge-font-weight timer-badge-background timer-badge-margin-alignment"
                >
                  {{
                    productDealCountDown.badge_message +
                      ' ' +
                      remainingTime.hoursToToday +
                      (remainingTime.hoursToToday > 1 ? ' Hours' : ' Hour')
                  }}
                </div>
              } @else if (
                remainingTime.daysToToday < 1 && remainingTime.hoursToToday < 1 && remainingTime.minutesToToday >= 1
              ) {
                <div
                  class="timer-badge timer-badge-text-size timer-badge-text-color timer-badge-font-weight timer-badge-background timer-badge-margin-alignment"
                >
                  {{
                    productDealCountDown.badge_message +
                      ' ' +
                      remainingTime.minutesToToday +
                      (remainingTime.minutesToToday > 1 ? ' Minutes' : ' Minute')
                  }}
                </div>
              } @else if (
                remainingTime.daysToToday < 1 &&
                remainingTime.hoursToToday < 1 &&
                remainingTime.minutesToToday < 1 &&
                remainingTime.secondsToToday >= 1
              ) {
                <div
                  class="timer-badge timer-badge-text-size timer-badge-text-color timer-badge-font-weight timer-badge-background timer-badge-margin-alignment"
                >
                  {{
                    productDealCountDown.badge_message +
                      ' ' +
                      remainingTime.secondsToToday +
                      (remainingTime.secondsToToday > 1 ? ' Seconds' : ' Second')
                  }}
                </div>
              }
            }
          }
        }

        <!-- Enhanced variant display with better image handling -->
        @if (
          !isMobile() &&
          categoryLayoutData().productCardData.advanceConfiguration?.desktop?.isProductVariantVisible &&
          colorVariants.length > 0
        ) {
          <div class="product-variants">
            @for (variant of colorVariants | slice: 0 : (isMobile() ? 1 : 2); track variant.color) {
              @if (variant.image) {
                <div class="variant">
                  <img [src]="variant.image" alt="variant" />
                </div>
              } @else {
                <div class="variant">
                  <img [src]="IMAGE_URLS.noImagePlaceholder" />
                </div>
              }
            }
            @if (colorVariants.length > (isMobile() ? 1 : 2)) {
              <span class="more-variant-count"> +{{ colorVariants.length - (isMobile() ? 1 : 2) }} </span>
            }
          </div>
        }

        <!-- Mobile variant display -->
        @if (
          isMobile() &&
          categoryLayoutData().productCardData.advanceConfiguration?.mobile?.isProductVariantVisible &&
          colorVariants.length > 0
        ) {
          <div class="product-variants">
            @for (variant of colorVariants | slice: 0 : (isMobile() ? 1 : 2); track variant.color) {
              <div class="variant">
                <img [src]="variant.image" alt="variant" />
              </div>
            }
            @if (colorVariants.length > (isMobile() ? 1 : 2)) {
              <span class="more-variant-count"> +{{ colorVariants.length - (isMobile() ? 1 : 2) }} </span>
            }
          </div>
        }
      </div>

      <div class="product-card-image-container">
        @if (previewImage) {
          <img [src]="previewImage" />
        } @else {
          <div class="product-card-image-container">
            <img [src]="IMAGE_URLS.noImagePlaceholder" />
          </div>
        }
      </div>
      <!-- Enhanced product card content with better responsive design -->
      <div class="product-card-content-container">
        <!-- Brand Name Display -->
        @if (!isMobile() && categoryLayoutData().productCardData.advanceConfiguration?.desktop?.isBrandNameVisible) {
          <div
            class="product-card-brand-name brand-name-text-size brand-name-text-color brand-name-font-weight brand-name-text-transform"
          >
            {{ productVariant?.brand?.name }}
          </div>
        }
        @if (isMobile() && categoryLayoutData().productCardData.advanceConfiguration?.mobile?.isBrandNameVisible) {
          <div
            class="product-card-brand-name brand-name-text-size brand-name-text-color brand-name-font-weight brand-name-text-transform"
          >
            {{ productVariant?.brand?.name }}
          </div>
        }

        <!-- Product Name -->
        <p
          class="product-card-product-name product-name-text-size product-name-text-color product-name-font-weight product-name-text-transform"
        >
          {{ product?.variant_group?.name || productVariant?.display_name || productVariant?.name }}
        </p>

        <!-- Enhanced Pricing Display -->
        <div class="product-card-price-container">
          <p
            class="product-card-discounted-price discounted-price-text-size discounted-price-text-color discounted-price-font-weight"
          >
            {{ _sellingPrice | indianCurrency }}
          </p>
          @if (_sellingPrice < _actualPrice) {
            <p
              class="product-card-actual-price actual-price-text-size actual-price-text-color actual-price-font-weight"
            >
              {{ _actualPrice | indianCurrency }}
            </p>
          }

          <!-- Enhanced Percentage Discount Display -->
          @if (
            (!isMobile() &&
              (categoryLayoutData().productCardData.advanceConfiguration?.desktop?.isPercentageDiscountVisible ??
                true)) ||
            (isMobile() &&
              (categoryLayoutData().productCardData.advanceConfiguration?.mobile?.isPercentageDiscountVisible ?? true))
          ) {
            @if (_sellingPrice < _actualPrice) {
              <p
                class="margin-info percentage-discount-text-size percentage-discount-text-color percentage-discount-font-weight"
              >
                {{ productVariant | productListingPercentageSave }}
              </p>
            }
          }
        </div>

        <!-- Cash Points section -->
        @if (cashPoints() > 0 && storeConfiguration()?.is_cashpoints_offer_active) {
          <div class="cash-point-container">
            Earn
            <cash-point-svg class="selector-cashpoint" width="100%" height="100%"></cash-point-svg>
            {{ cashPoints() | mathFloor }} CashPoints
          </div>
        }

        <!-- TODO variant viewer -->
        <!-- <base-variant-viewer
    
    *ngIf="colorVariants?.length"
    [showImages]="showImages"
    (mouseEnterIndex)="setPreviewImage($event)"
    (mouseLeaveIndex)="clearPreviewImage()"
    [variants]="colorVariants"
  >
  </base-variant-viewer> -->
      </div>
    </div>

    <!-- Enhanced card actions with improved visibility logic -->
    @if (
      (!isMobile() && categoryLayoutData().productCardData.advanceConfiguration?.desktop?.isPreviewDetailsVisible) ||
      (isMobile() && categoryLayoutData().productCardData.advanceConfiguration?.mobile?.isPreviewDetailsVisible) ||
      (((!isMobile() && categoryLayoutData().productCardData.advanceConfiguration?.desktop?.isAddToCartVisible) ||
        (isMobile() && categoryLayoutData().productCardData.advanceConfiguration?.mobile?.isAddToCartVisible)) &&
        !isVariantAvailable)
    ) {
      <div class="card-actions">
        <!-- Preview Details Button -->
        @if (
          (!isMobile() &&
            categoryLayoutData().productCardData.advanceConfiguration?.desktop?.isPreviewDetailsVisible) ||
          (isMobile() && categoryLayoutData().productCardData.advanceConfiguration?.mobile?.isPreviewDetailsVisible)
        ) {
          <div
            class="preview-details-button preview-details-button-background preview-details-button-border preview-details-button-border-top-left-radius preview-details-button-border-top-right-radius preview-details-button-border-bottom-right-radius preview-details-button-border-bottom-left-radius"
            [class.width-custom]="isVariantAvailable || !isAddToCartVisible"
            (click)="openProductDetailOverlay(); $event.stopPropagation(); $event.stopImmediatePropagation()"
          >
            <span
              class="preview-details-label-text-size preview-details-label-text-color preview-details-label-text-font-weight desktop-view"
            >
              Preview Details
            </span>
            <span
              class="preview-details-label-text-size preview-details-label-text-color preview-details-label-text-font-weight mobile-view"
            >
              PREVIEW
            </span>
          </div>
        }

        <!-- Add to Cart Wrapper -->
        @if (!isVariantAvailable && isAddToCartVisible) {
          <div class="add-cart-view-detail-wrapper" [class.width-custom]="!isPreviewDetailsVisible">
            @if (
              !isMobile() && categoryLayoutData().productCardData.advanceConfiguration?.desktop?.isAddToCartVisible
            ) {
              <webstore-add-to-cart-action
                [productInput]="productVariant"
                [isDisplayAddToCartTextInput]="isAddToCartVisible"
              ></webstore-add-to-cart-action>
            }
            @if (isMobile() && categoryLayoutData().productCardData.advanceConfiguration?.mobile?.isAddToCartVisible) {
              <webstore-add-to-cart-action
                [productInput]="productVariant"
                [isDisplayAddToCartTextInput]="isAddToCartVisible"
              ></webstore-add-to-cart-action>
            }
          </div>
        }
      </div>
    }

    <!-- Enhanced hover state countdown with better styling -->
    @if (remainingTime(); as remainingTime) {
      @if (remainingTime.remainingTime > 1000) {
        @if (categoryLayoutData().productCardData.advanceConfiguration?.desktop?.isDealCountdownVisible) {
          @if (!isMobile()) {
            <div
              class="countdown-container countdown-container-background countdown-container-text-color countdown-container-text-size countdown-container-font-weight"
            >
              @if (productDealCountDown?.description) {
                <p class="countdown-container-title">
                  {{ productDealCountDown.description }}
                </p>
              }
              <div class="wrapper">
                <div class="block">
                  <span
                    class="top countdown-value-text-size countdown-value-text-color countdown-value-font-weight countdown-value-background countdown-value-border-top-left-radius countdown-value-border-top-right-radius countdown-value-border-bottom-right-radius countdown-value-border-bottom-left-radius"
                  >
                    {{ remainingTime?.daysToToday }}
                  </span>
                  <span
                    class="bottom countdown-label-text-size countdown-label-text-color countdown-label-font-weight countdown-label-background countdown-label-border-top-left-radius countdown-label-border-top-right-radius countdown-label-border-bottom-right-radius countdown-label-border-bottom-left-radius"
                  >
                    {{ remainingTime.daysToToday > 1 ? 'Days' : 'Day' }}
                  </span>
                </div>
                :
                <div class="block">
                  <span
                    class="top countdown-value-text-size countdown-value-text-color countdown-value-font-weight countdown-value-background countdown-value-border-top-left-radius countdown-value-border-top-right-radius countdown-value-border-bottom-right-radius countdown-value-border-bottom-left-radius"
                  >
                    {{ remainingTime?.hoursToToday }}
                  </span>
                  <span
                    class="bottom countdown-label-text-size countdown-label-text-color countdown-label-font-weight countdown-label-background countdown-label-border-top-left-radius countdown-label-border-top-right-radius countdown-label-border-bottom-right-radius countdown-label-border-bottom-left-radius"
                  >
                    {{ remainingTime.hoursToToday > 1 ? 'Hours' : 'Hour' }}
                  </span>
                </div>
                :
                <div class="block">
                  <span
                    class="top countdown-value-text-size countdown-value-text-color countdown-value-font-weight countdown-value-background countdown-value-border-top-left-radius countdown-value-border-top-right-radius countdown-value-border-bottom-right-radius countdown-value-border-bottom-left-radius"
                  >
                    {{ remainingTime?.minutesToToday }}
                  </span>
                  <span
                    class="bottom countdown-label-text-size countdown-label-text-color countdown-label-font-weight countdown-label-background countdown-label-border-top-left-radius countdown-label-border-top-right-radius countdown-label-border-bottom-right-radius countdown-label-border-bottom-left-radius"
                  >
                    {{ remainingTime.minutesToToday > 1 ? 'Mins' : 'Min' }}
                  </span>
                </div>
                :
                <div class="block">
                  <span
                    class="top countdown-value-text-size countdown-value-text-color countdown-value-font-weight countdown-value-background countdown-value-border-top-left-radius countdown-value-border-top-right-radius countdown-value-border-bottom-right-radius countdown-value-border-bottom-left-radius"
                  >
                    {{ remainingTime?.secondsToToday }}
                  </span>
                  <span
                    class="bottom countdown-label-text-size countdown-label-text-color countdown-label-font-weight countdown-label-background countdown-label-border-top-left-radius countdown-label-border-top-right-radius countdown-label-border-bottom-right-radius countdown-label-border-bottom-left-radius"
                  >
                    {{ remainingTime.secondsToToday > 1 ? 'Secs' : 'Sec' }}
                  </span>
                </div>
              </div>
            </div>
          }
        }
      }
    }
  </div>
</section>
